/* ==========================================================================
   Naudet (ClaudIA) — bouton « Acheter maintenant » — 2026-08-05

   Demande de François, relayée par Morgane : sur la fiche produit, le bouton
   principal affichait « Payer avec PayPal », ce qui laisse croire que PayPal
   est le seul moyen de paiement. Ils veulent un bouton neutre qui mène à la
   page de paiement, où l'on choisit entre carte, PayPal, Klarna ou chèque.

   Pourquoi ce bouton est écrit à la main plutôt que réglé : le libellé
   « Payer avec PayPal » vient de Shopify, pas du thème. Le bouton natif de
   paiement accéléré prend le nom du portefeuille actif, et PayPal est le seul
   de cette boutique. On masque donc ce bouton (réglage de thème) et on pose
   le nôtre à sa place.

   Ce que fait le bouton : il ajoute l'article au panier comme le ferait
   « Ajouter au panier », puis ouvre directement la page de paiement.

   ⚠ ÉCART ASSUMÉ AVEC LE BOUTON DE SHOPIFY : celui de Shopify n'emmène QUE
     l'article courant au paiement et laisse le panier de côté. Le nôtre
     emmène le panier entier, article courant compris. C'est le comportement
     le moins surprenant pour un client qui aurait déjà mis quelque chose dans
     son panier — mais ce n'est pas le même, et il faut le savoir.

   ⚠ La délégation est posée sur le document : le thème re-rend la fiche
     produit à chaque changement de déclinaison, donc un écouteur posé sur le
     bouton lui-même disparaîtrait au premier clic sur une déclinaison.
   ========================================================================== */

(function () {
  'use strict';

  var SELECTEUR = '[data-naudet-acheter-maintenant]';

  function racine() {
    // Boutique en une seule langue aujourd'hui, mais `Shopify.routes.root`
    // porte le préfixe de langue s'il en apparaît un : autant s'en servir.
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function erreur(bouton, message) {
    var zone = bouton.parentElement.querySelector('.naudet-acheter-erreur');
    if (!zone) {
      zone = document.createElement('span');
      zone.className = 'naudet-acheter-erreur';
      bouton.parentElement.appendChild(zone);
    }
    zone.textContent = message;
  }

  document.addEventListener('click', function (ev) {
    var bouton = ev.target.closest ? ev.target.closest(SELECTEUR) : null;
    if (!bouton || bouton.disabled) return;

    var form = bouton.closest('form[data-type="add-to-cart-form"]');
    if (!form) return; // hors formulaire produit : on laisse faire le thème

    // Le bouton est de type button, mais une page peut être servie avant que
    // ce script ne soit chargé : on neutralise l'envoi du formulaire dans
    // tous les cas.
    ev.preventDefault();
    ev.stopPropagation();

    var libelle = bouton.textContent;
    bouton.disabled = true;
    bouton.setAttribute('aria-busy', 'true');
    erreur(bouton, '');

    fetch(racine() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form),
    })
      .then(function (rep) {
        return rep.json().then(function (corps) {
          if (!rep.ok) throw new Error(corps.description || corps.message || '');
          return corps;
        });
      })
      .then(function () {
        window.location.href = racine() + 'checkout';
      })
      .catch(function (e) {
        // Rupture de stock, règle de quantité, réseau coupé : on rend la main
        // au client plutôt que de l'emmener sur un paiement vide.
        bouton.disabled = false;
        bouton.removeAttribute('aria-busy');
        bouton.textContent = libelle;
        erreur(bouton, e.message || "L'article n'a pas pu être ajouté au panier.");
      });
  });
})();
